// ConnectApp.js
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Routes } from "../routes";
import { ProtectedRoute } from "../ProtectedRoute";

// Páginas públicas
import Signin from "./examples/Signin";
import Signup from "./examples/Signup";
import ForgotPassword from "./examples/ForgotPassword";
import ResetPassword from "./examples/ResetPassword";
import NotFoundPage from "./examples/NotFound";
import Connect from "./connect";


// Dashboard e Sidebar
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";

// Admin
import DashboardAdmin from "./dashboard/admin/dashboardAdmin";
import Praticantes from "./dashboard/admin/praticantesAdmin";
import Turmas from "./dashboard/admin/turmasAdmin";
import Aulas from "./dashboard/admin/aulasAdmin";
import Eventos from "./dashboard/admin/eventosAdmin";
import Pagamentos from "./dashboard/admin/pagamentosAdmin";
import Utilizadores from "./dashboard/admin/utilizadoresAdmin";
import Mensagens from "./dashboard/admin/mensagensAdmin";

// User
import DashboardUser from "./dashboard/user/dashboardUser";
import PraticantesUser from "./dashboard/user/praticantesUser";
import AulasUser from "./dashboard/user/aulasUser";
import EventosUser from "./dashboard/user/eventosUser";
import PagamentosUser from "./dashboard/user/pagamentosUser";
import MensagensUser from "./dashboard/user/mensagensUser";

// Perfil
import Perfil from "./dashboard/perfil";

/**
 * Route com Sidebar (para páginas protegidas)
 */
const RouteWithSidebar = ({ component: Component, ...rest }) => {
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => setLoaded(true), 500);
        return () => clearTimeout(timer);
    }, []);

    const WrappedComponent = (props) => (
        <>
            <Preloader show={!loaded} />
            <Sidebar />
            <main className="content">
                <Navbar />
                <Component {...props} />
                <Footer />
            </main>
        </>
    );

    return (
        <ProtectedRoute
            {...rest}
            component={WrappedComponent}
        />
    );
};


/**
 * Rotas do Connect
 */
export default function ConnectApp() {
    return (
        <Switch>
            {/* Páginas públicas */}
            <Route exact path={Routes.Signin.path} component={Signin} />
            <Route exact path={Routes.Signup.path} component={Signup} />
            <Route exact path={Routes.ForgotPassword.path} component={ForgotPassword} />
            <Route exact path={Routes.ResetPassword.path} component={ResetPassword} />
            <Route exact path={Routes.NotFound.path} component={NotFoundPage} />
            <Route exact path={Routes.Connect.path} component={Connect} />

            {/* Admin */}
            <RouteWithSidebar exact path={Routes.dashboardAdmin.path} component={DashboardAdmin} />
            <RouteWithSidebar exact path={Routes.Praticantes.path} component={Praticantes} />
            <RouteWithSidebar exact path={Routes.Turmas.path} component={Turmas} />
            <RouteWithSidebar exact path={Routes.Aulas.path} component={Aulas} />
            <RouteWithSidebar exact path={Routes.Eventos.path} component={Eventos} />
            <RouteWithSidebar exact path={Routes.Pagamentos.path} component={Pagamentos} />
            <RouteWithSidebar exact path={Routes.Utilizadores.path} component={Utilizadores} />
            <RouteWithSidebar exact path={Routes.Mensagens.path} component={Mensagens} />

            {/* User */}
            <RouteWithSidebar exact path={Routes.dashboardUser.path} component={DashboardUser} />
            <RouteWithSidebar exact path={Routes.PraticantesUser.path} component={PraticantesUser} />
            <RouteWithSidebar exact path={Routes.AulasUser.path} component={AulasUser} />
            <RouteWithSidebar exact path={Routes.EventosUser.path} component={EventosUser} />
            <RouteWithSidebar exact path={Routes.PagamentosUser.path} component={PagamentosUser} />
            <RouteWithSidebar exact path={Routes.MensagensUser.path} component={MensagensUser} />

            {/* Perfil */}
            <RouteWithSidebar exact path={Routes.Perfil.path} component={Perfil} />

            {/* fallback */}
            <Redirect to={Routes.NotFound.path} />
        </Switch>
    );
}
